import styled from "styled-components";
import { Flex, Text } from "@fluentui/react-northstar";

export const Number = styled.span`
    font-style: normal;
    font-weight: ${({ active, already }) =>
        active === "true" ? "700" : already === "true" ? "400" : "100"};
    font-size: 14px;
    line-height: 20px;

    color: ${({ active, already }) =>
        active === "true" ? "white" : already === "true" ? "black" : "#979593"};
`;

export const TextPrimary = styled(Text)`
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;

    color: #242424;
`;

export const Ball = styled(Flex)`
    background-color: ${({ active, already }) =>
        active === "true"
            ? "#5b5fc7"
            : already === "true"
            ? "white"
            : "#FAF9F8"};
    width: 32px;
    height: 32px;
    border-radius: 50%;
`;
